<template>
    <div class="pt-4">
        <v-select
            v-model="formData.serviceFeeCurrency"
            :items="useCurrency"
            :label="$t('currency')"
            :rules="[requiredRule('currency')]"
            data-cy="service-fee-currency"
            max-width="200"
        />
        <TreeViewCalculation
            v-model="formData.serviceFeeRuleRoot"
            :currency="formData.currency"
            :label="$t('service_fee')"
            :is-show-service-fee="true"
        />
    </div>
</template>
<script setup lang="ts">
    import {requiredRule} from '~/composables/rules'
    import TreeViewCalculation from '~/components/salesSettings/TreeViewCalculation.vue'

    const formData = defineModel<any>()
</script>
